import React from 'react';
import {Box, Popover} from '@lapilli-ui/components';

import {useMediaQuery} from '../../utils/functions';

const PopoverWithContent = ({children, ...props}) => {
  const isSmallDevice = useMediaQuery('(max-width: 600px)');
  return (
      <>
        {!isSmallDevice && <Popover {...props}>
          <Box className="popover-content">
            {children}
          </Box>
        </Popover>}
        {isSmallDevice &&
            <Box className="mobile-search-content">
              {children}
            </Box>
        }
      </>
  );
};

export default PopoverWithContent;